import { render, staticRenderFns } from "./PDFInfo.vue?vue&type=template&id=63332180&scoped=true&"
import script from "./PDFInfo.vue?vue&type=script&lang=js&"
export * from "./PDFInfo.vue?vue&type=script&lang=js&"
import style0 from "./PDFInfo.vue?vue&type=style&index=0&id=63332180&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63332180",
  null
  
)

export default component.exports